<div class="page-padding">
  <!--component setup panel-->
  <div class="panel" style="padding: 1%;">
    <div class="panel__header">
      <!--Main header-->
      <span class="panel__header__title">{{'Additional Component Setup' | translate | async}}</span>
    </div>

    <mat-card class="panel_search mat-card">
      <!--sub header-->
      <div class="panel_sub_header">
        <span class="panel__header__title">{{'Additional Component Selection' | translate | async}}</span>
      </div>
      <!--search form-->
      <mat-form-field class="header-form-full-width">
        <span class="label">{{"Family" | translate | async}}</span>
        <mat-select id="select-family" placeholder="{{'Select Family'  | translate | async}}" [(ngModel)]="selectedFamily"  ngDefaultControl multiple>
          <mat-option [value]="family.Id" *ngFor="let family of familyList">
            <!-- {{family.Title + ' | ' + family.Symbol}} -->
            {{family.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <span class="label">{{'Make' | translate | async}}</span>
        <mat-select id="select-make" placeholder="{{'Select Make'  | translate | async}}" [(ngModel)]="selectedMake"
          (selectionChange)="loadModelList()" ngDefaultControl multiple>
          <mat-option [value]="make.Id" *ngFor="let make of makeList">
            {{make.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="header-form-full-width">
        <span class="label">{{'Model' | translate | async}}</span>
        <mat-select id="select-model" placeholder="{{'Select Model'  | translate | async}}" [(ngModel)]="selectedModel" ngDefaultControl multiple>
          <mat-option [value]="model.Id" *ngFor="let model of modelList">
            {{model.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>



      <div class="bottom-row" style="display: flex; place-content: flex-end;">
        <a class="button"><span class="button__text" (click)="componentSetupFormRest()">Reset</span></a>
        <a class="button button--primary"><i class="material-icons button__icon"></i><span class="button__text"
            (click)="GetComponentListForGrid()">{{'Search' | translate | async}}</span></a>
      </div>
       <!--Table View-->
       <div *ngIf="showTableView" class="table-container ">
        <!--Table-->
        <mat-table class=" mat-elevation-z8" #table [dataSource]="dataSource" matSort style="width: 100%;">
          <ng-container matColumnDef="AdditionalComponent">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Additional Component' | translate | async}} </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.AddiCompName}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="System">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{'System' | translate | async}} </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.System}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Side">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Side' | translate | async}} </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.Side==true?('Both' | translate | async ): ('No Side'  | translate | async)}} </mat-cell>
          </ng-container>

          <ng-container matColumnDef="Model">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{'Model'  | translate | async}} </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.ModelName}} </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns; " [ngClass]="{ 'selected': row === selectedRow }"
            (click)="selectRow(row)"></mat-row>
        </mat-table>
      </div>
    </mat-card>

    <mat-card class="panel_search mat-card">
      <!--sub header-->
      <div class="panel_sub_header">
        <span class="panel__header__title">{{'Additional Component Details'  | translate | async}}</span>
      </div>
        <div style="width: 100%;">
        <div style=" display: flex; justify-content: space-between;">
          <mat-form-field class="header-form-full-width" style="padding: 1%;">
            <input matInput name="componentName_" required [(ngModel)]="componentName" #partNo_="ngModel" placeholder="{{'Additional Component Name'  | translate | async}}">
          </mat-form-field>
          <mat-form-field class="header-form-full-width" style="padding: 1%;">
            <mat-select [(ngModel)]="selectedSystem" placeholder="{{'Select System'  | translate | async}}" required>
              <mat-option [value]="0">{{'No System'  | translate | async}}</mat-option>
              <mat-option [value]="2">{{'Chain'  | translate | async}}</mat-option>
              <mat-option [value]="1">{{'Frame'  | translate | async}}</mat-option>
            </mat-select>
          </mat-form-field>
  
         <mat-form-field class="header-form-full-width" style="padding: 1%;">
            <mat-select [(ngModel)]="selectedSide" placeholder="{{'Select Side' | translate | async}}" required>
              <mat-option [value]="1">{{'No Side'  | translate | async}}</mat-option>
              <mat-option [value]="2">{{'Both'  | translate | async}}</mat-option>
            </mat-select>
          </mat-form-field>
  
          <mat-form-field class="header-form-full-width" style="padding: 1%;">
            <mat-select [(ngModel)]="selectesIsBogie" placeholder="{{'Is Bogie' | translate | async}}" required>
              <mat-option [value]="1">{{'Yes'  | translate | async}}</mat-option>
              <mat-option [value]="2">{{'No'  | translate | async}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field  *ngIf="isNew==false" class="header-form-full-width" style="padding: 1%;">
            <mat-select placeholder="{{'Model'  | translate | async}}" name="moduleid__" [(ngModel)]="selectedModelId" #moduleid__="ngModel" required>
              <mat-option [value]="model.Id" *ngFor="let model of _componentservice.availableModelList">
                {{model.Title}}
              </mat-option>
            </mat-select>
            <mat-error>{{'Please select a Model'  | translate | async}}</mat-error>
          </mat-form-field>
        </div>
        
        <div style="display: flex;" *ngIf="isNew==true">
          <mat-form-field class="shared-component-e-d-slect-containers" style="padding: 1%; width: 25%;">
            <mat-select placeholder="{{'Model'  | translate | async}}" name="moduleid_" [(ngModel)]="moduleid" #moduleid_="ngModel" required>
              <mat-option [value]="model.Id" *ngFor="let model of _componentservice.availableModelList">
                {{model.Title}}
              </mat-option>
            </mat-select>
            <mat-error>{{'Please select a Model'  | translate | async}}</mat-error>
          </mat-form-field>

          <div class="apply-module-container" style="width: 73%;">
            <div>
              <a class="apply-module-container-add-button button button--primary"><i class="material-icons button__icon"
                  style="margin-right: 0px"></i><span class="button__text" (click)="addModel(0)">{{'Add'  | translate | async}}</span></a>
            </div>
            <!--mat chip-->
            <mat-form-field style="width:100%;overflow-y: auto; max-height: 100px">
              <mat-chip-list #chipList>
                <mat-chip *ngFor="let title of modelNameID" [selectable]="selectable" [removable]="removable"
                  (remove)="removeModel(title)">
                  {{title}}
                  <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                </mat-chip>
                <input placeholder="{{'Apply Models...' | translate | async}}" [matChipInputFor]="chipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" />
              </mat-chip-list>
            </mat-form-field>
            <!--end mat chip-->
          </div>
        </div>
        <div class="margin-bottom-24">
          <div class="input-group-description">{{'You can attach a photo.'  | translate | async}} </div>
          <input #userPhoto type='file' accept="image/*" (change)="onSelectEquipmentPhoto($event)">
          <div style="margin-top: 8px;">
            <img *ngIf="imageUrl_" [src]="getImage(imageUrl_)" height="300">
          </div>
        </div>

        <div class="bottom-row" style="display: flex; place-content: flex-end;" *ngIf="isNew==true">
          <a class="button"><span class="button__text" (click)="componentSetupFormRest()">{{'Reset'  | translate | async}}</span></a>
          <a class="button button--primary"><i class="material-icons button__icon"></i><span class="button__text"
              (click)="CreateNewComponenet()">{{'Add New'  | translate | async}}</span></a>
        </div>

        <div class="bottom-row" style="display: flex; place-content: flex-end;" *ngIf="isNew==false">
          <!-- <a class="button"><span class="button__text" (click)="DeleteComponent()">Delete</span></a> -->
          <a class="button button--primary"><i class="material-icons button__icon"></i><span class="button__text"
              (click)="UpdateComponent()">{{'Update'  | translate | async}}</span></a>
        </div>
      </div>
    </mat-card>
  </div>
</div>